/*
  The following functions are taken from the following github project:
  https://github.com/Telegram-Mini-Apps/tma.js

  They should be tested with actual devices.
*/
const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

// Telegram Web
// https://github.com/Telegram-Mini-Apps/tma.js/blob/master/packages/sdk/src/env/isIframe.ts
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
const isIframe = (): boolean => window?.self !== window?.top;

// Telegram for window phone or android
// https://github.com/Telegram-Mini-Apps/tma.js/blob/master/packages/sdk/src/env/hasExternalNotify.ts
const hasExternalNotify = <T extends object>(
  value: T,
): value is T & {
  readonly external: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    readonly notify: (...args: any) => any;
  };
} =>
  'external' in value &&
  isRecord(value) &&
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  'notify' in value.external &&
  typeof value.external.notify === 'function';

// Telegram for iOS and macOS
// https://github.com/Telegram-Mini-Apps/tma.js/blob/master/packages/sdk/src/env/hasWebviewProxy.ts
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
const hasWebviewProxy = <T extends {}>(
  value: T,
): value is T & {
  readonly TelegramWebviewProxy: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    readonly postEvent: (...args: any) => any;
  };
} =>
  'TelegramWebviewProxy' in value &&
  isRecord(value.TelegramWebviewProxy) &&
  'postEvent' in value.TelegramWebviewProxy &&
  typeof value.TelegramWebviewProxy.postEvent === 'function';

export const isTelegramApp = (window: Window): boolean =>
  isIframe() || hasExternalNotify(window) || hasWebviewProxy(window);
